module.exports = __webpack_public_path__ + "img/error-network.a6dbf6a4.svg";